import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const Icon = styled.img`
  cursor: pointer;
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: normal;
  text-align: center;
`;

export const Header = styled.p`
  color: #101212;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 28.8px;
  margin-bottom: 0;
  @media screen and (max-width: 767px) {
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

// Container that floats near selection
export const CommentSidebar = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 9999px;
  padding: 8px 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

// Individual button (icon-style)
export const CommentButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 2px;
  margin: 2px 0;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }
`;
